export const COMMENT_CONFIDENTIALITY_THRESHOLD = 15;
